import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { reportError } from '@/domains/observability'

import { sendInvoice } from './api'
import { useInvalidateInvoices } from './use-invalidate-invoices'

export function useSendInvoice() {
  const invalidate = useInvalidateInvoices()
  return useMutation({
    mutationFn: (id: string) => sendInvoice(id),
    onSuccess: invoice => {
      invalidate(invoice.id)
      toast.success(`Invoice ${invoice.invoiceNumber} sent`)
    },
    onError: error => {
      reportError(error)
      toast.error('Failed to send invoice')
    }
  })
}
